import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Footer from "./components/Footer";
import Policy from "./pages/Policy";
import { projectData } from "./data/projectData";
import Chatbot from "./pages/Chatbot";
import ThankYouScreen from "./pages/ThankYouScreen";

function App() {
  return (
    <Router>
      <MainApp />
    </Router>
  );
}

const MainApp = () => {
  const location = useLocation();

  const isFullWidthPage = location.pathname === "/policy";

  const isThankYouPage = location.pathname === "/thank-you";

  return (
    <>
      {/* Navbar (Hide on Thank You Page) */}
      {!isThankYouPage && <Navbar fullWidth={isFullWidthPage} />}

      {/* Main Routes */}
      <main
        className={`
          ${isFullWidthPage ? "pt-[40px]" : "pb-20 lg:pb-0"}
          ${isThankYouPage ? "p-0" : "pb-20 lg:pb-0"}
        `}
      >
        <Routes>
          <Route path="/" element={<Hero data={projectData} />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/thank-you" element={<ThankYouScreen />} />
        </Routes>

        {/* Footer (Hide on Thank You Page) */}
        {!isThankYouPage && <Footer fullWidth={isFullWidthPage} />}

        {!isThankYouPage && <Chatbot />}
      </main>
    </>
  );
};

export default App;
